<template>
	<div class="customer-photo-upload">
		<div class="photo-header">
			<span class="photo-title">{{ title }}</span>
			<span class="photo-limit">仅支持1张</span>
		</div>
		<div
			class="photo-body"
			v-loading="loading"
			element-loading-text="图片上传中"
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"
			@click="uploadHandler"
			@mouseover="imgMouseOver"
			@mouseout="imgMouseOut"
		>
			<template v-if="!previewSrc">
				<div class="photo-empty">
					<i class="el-icon-picture-outline photo-icon"></i>
					<p class="photo-action">点击上传{{ title }}</p>
					<p class="photo-tip">支持 JPG、JPEG、PNG，大小不超过 10MB</p>
				</div>
			</template>
			<template v-else>
				<div class="photo-preview">
					<w-image :src="previewSrc" class="photo-img"></w-image>
					<div class="photo-mask" v-show="activeFlag">
						<el-button type="primary" size="mini" icon="el-icon-search" @click.stop="previewClick"></el-button>
						<el-button v-if="canEdit" type="primary" size="mini" icon="el-icon-upload" @click.stop="uploadHandler"></el-button>
						<el-button v-if="canEdit" type="danger" size="mini" icon="el-icon-delete" @click.stop="deleteClick"></el-button>
					</div>
				</div>
			</template>
		</div>
		<input
			type="file"
			ref="file"
			accept="image/png,image/jpeg,image/jpg"
			v-show="false"
			@change="getFile"
		>
		<el-dialog
			:title="title || '图片预览'"
			:visible.sync="previewVisible"
			append-to-body
			width="720px"
			top="8vh"
			class="customer-photo-preview-dialog"
			:close-on-click-modal="false"
		>
			<div class="preview-dialog-body">
				<img :src="previewSrc" class="preview-dialog-img" alt="">
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'CustomerPhotoUpload',
	props: {
		title: {
			type: String,
			default: ''
		},
		imgSrc: {
			type: String,
			default: ''
		},
		canEdit: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			previewSrc: '',
			loading: false,
			activeFlag: false,
			previewVisible: false,
			uploadType: /image\/png|image\/jpg|image\/jpeg/,
			uploadSize: 10
		}
	},
	watch: {
		imgSrc (val) {
			this.previewSrc = val || ''
			if (this.$refs.file) {
				this.$refs.file.value = ''
			}
		}
	},
	created () {
		this.previewSrc = this.imgSrc || ''
	},
	methods: {
		imgMouseOver () {
			if (this.previewSrc) {
				this.activeFlag = true
			}
		},
		imgMouseOut () {
			this.activeFlag = false
		},
		previewClick () {
			if (!this.previewSrc) {
				return
			}
			this.previewVisible = true
		},
		uploadHandler () {
			if (!this.canEdit) {
				return
			}
			this.$refs.file.click()
		},
		getFile (e) {
			const files = e.target.files[0]
			if (!files) {
				return
			}
			const type = files.type
			const size = files.size / 1024 / 1024
			if (!this.uploadType.test(type)) {
				this.$message.error('上传图片只支持 JPG、JPEG、PNG 格式!')
				this.$refs.file.value = ''
				return
			}
			if (size > this.uploadSize) {
				this.$message.error(`上传图片大小不能超过${this.uploadSize}MB!`)
				this.$refs.file.value = ''
				return
			}
			const formData = new FormData()
			formData.append('extension', files.type.split('/')[1])
			formData.append('file', files)
			this.loading = true
			this.$store.dispatch('requestFilePost', {
				url: `${this.$fxBaseApi.urlQIVShop}/upload/pic/tempcompression`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.previewSrc = res.data
					this.$emit('update:imgSrc', res.data)
					this.$message.success('上传成功')
				} else {
					this.$message.error(res.msg || '上传图片失败')
				}
			}).catch(() => {
				this.$message.error('上传图片失败')
			}).finally(() => {
				this.loading = false
				this.$refs.file.value = ''
			})
		},
		deleteClick () {
			if (!this.canEdit) {
				return
			}
			this.$confirm('是否删除该图片？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.previewSrc = ''
				this.$refs.file.value = ''
				this.$emit('update:imgSrc', '')
			}).catch(() => {})
		}
	}
}
</script>

<style lang="stylus" scoped>
.customer-photo-upload {
	width: 260px;
	min-width: 260px;
	max-width: 260px;
	flex: 0 0 260px;
	box-sizing: border-box;
	overflow: visible;
	.photo-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 8px;
		width: 100%;
		box-sizing: border-box;
		white-space: nowrap;
		.photo-title {
			font-size: 14px;
			color: #303133;
			font-weight: 500;
			flex-shrink: 0;
			white-space: nowrap;
		}
		.photo-limit {
			font-size: 12px;
			color: #909399;
			flex-shrink: 0;
			white-space: nowrap;
			margin-left: 8px;
		}
	}
	.photo-body {
		width: 260px;
		min-width: 260px;
		max-width: 260px;
		height: 130px;
		border: 1px dashed #dcdfe6;
		border-radius: 4px;
		background: #fafafa;
		box-sizing: border-box;
		cursor: pointer;
		overflow: hidden;
		&:hover {
			border-color: var(--fx-primary-color);
		}
		.photo-empty {
			height: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 0 12px;
			box-sizing: border-box;
			.photo-icon {
				font-size: 36px;
				color: #c0c4cc;
				margin-bottom: 8px;
			}
			.photo-action {
				font-size: 13px;
				color: #606266;
				line-height: 20px;
				margin: 0 0 6px;
			}
			.photo-tip {
				font-size: 12px;
				color: #909399;
				line-height: 18px;
				margin: 0;
				text-align: center;
			}
		}
		.photo-preview {
			position: relative;
			width: 100%;
			height: 100%;
			.photo-img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
			.photo-mask {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				background: rgba(0, 0, 0, 0.35);
				.el-button {
					margin: 0 4px;
					padding: 7px;
				}
			}
		}
	}
}
</style>
<style lang="stylus">
.customer-photo-preview-dialog {
	.el-dialog {
		margin-bottom: 0;
	}
	.el-dialog__body {
		padding: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 68vh;
		max-height: 68vh;
		overflow: hidden;
		box-sizing: border-box;
	}
	.preview-dialog-body {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		.preview-dialog-img {
			display: block;
			max-width: 100%;
			max-height: 100%;
			width: auto;
			height: auto;
			object-fit: contain;
			margin: 0 auto;
		}
	}
}
</style>
